<body>
<!-- ============================================================== -->
<!-- Preloader - style you can find in spinners.css -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div id="main-wrapper">

  <div style="width: 100%; align-content: center; margin-top: 10%; margin-bottom: 10%">
    <div class="login-div">
      <mat-card *ngIf="mod==0">
        <!--<mat-progress-bar *ngIf="inProgres" mode="indeterminate"></mat-progress-bar><br>-->
        <mat-card-title style="display: inline;margin-left: 74px">{{'login.card-title'|translate}}</mat-card-title>
        <button style="display: inline; margin-left: 64%; font-size: 17px" mat-button>
          <a class="nav-link" href="/home">{{'login.button-home'|translate}}</a>
        </button>
        <br><br>
        <mat-form-field style="width: 80%; margin-left: 10%">
          <input matInput placeholder="{{'login.email-placeholder'|translate}}" [formControl]="email" required>
          <mat-error *ngIf="email.invalid">{{getEmailErrorMessage()}}</mat-error>
        </mat-form-field>
        <mat-form-field style="width: 80%; margin-left: 10%">
          <input type="password" matInput placeholder="{{'login.password-placeholder'|translate}}" [formControl]="password" value = "" required>
          <mat-error *ngIf="password.invalid">{{getPassworErrorMessage()}}</mat-error>
        </mat-form-field>
        <br><br>
        <button (keyup.enter)="doLogIn()" (click)="doLogIn()"
                style="width: 80%; margin-left: 10%; display: inline"
          class="btn btn-primary" type="button" [disabled]="inProgres">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="inProgres"></span>
          {{'login.button-login'|translate}}
        </button>
        <br><br>
        <p style="margin-left: 10%" class="subtitle">
          <a class="link" style="color: #8d97ad" href="/sign-in">Registra un account</a>
        </p>
        <p style="margin-left: 10%" class="subtitle">
          <a class="link" style="color: #8d97ad" href="javascript:void(0)" (click)="mod=1">Reimposta Password</a>
        </p>
      </mat-card>
      <mat-card *ngIf="mod==1">
        <!--<mat-progress-bar *ngIf="inProgres" mode="indeterminate"></mat-progress-bar><br>-->
        <mat-card-title style="display: inline;margin-left: 74px">{{'login.card-title'|translate}}</mat-card-title>
        <button style="display: inline; margin-left: 64%; font-size: 17px" mat-button>
          <a class="nav-link" href="/home">{{'login.button-home'|translate}}</a>
        </button>
        <br><br>
        <mat-form-field style="width: 80%; margin-left: 10%">
          <input matInput placeholder="{{'login.email-placeholder'|translate}}" [formControl]="email" required>
          <mat-error *ngIf="email.invalid">{{getEmailErrorMessage()}}</mat-error>
        </mat-form-field>
        <br><br>
        <button (keyup.enter)="sendResetPassword()" (click)="sendResetPassword()"
                style="width: 80%; margin-left: 10%; display: inline"
                class="btn btn-primary" type="button" [disabled]="inProgres">
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="inProgres"></span>
          Reimposta la password
        </button>
        <br><br>
        <p style="margin-left: 10%" class="subtitle">
          <a class="link" style="color: #8d97ad" href="javascript:void(0)" (click)="mod=0">Torna al login</a>
        </p>
      </mat-card>
      <mat-card *ngIf="mod==2">
        <!--<mat-progress-bar *ngIf="inProgres" mode="indeterminate"></mat-progress-bar><br>-->
        <mat-card-title style="display: inline;margin-left: 74px">{{'login.card-title'|translate}}</mat-card-title>
        <button style="display: inline; margin-left: 64%; font-size: 17px" mat-button>
          <a class="nav-link" href="/home">{{'login.button-home'|translate}}</a>
        </button>
        <br><br>
        <p style="margin-left: 10%">Controlla la tua casella email per reimpostare la password.</p>
      </mat-card>
    </div>
  </div>

  <app-footer></app-footer>


</div>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- All Jquery -->
<!-- ============================================================== -->

</body>


